import { IRateTypes } from '../../types'
import { RATE_FIELD_PLACEHOLDERS, TRateFieldPlaceholders } from './constants'

/**
 * Returns the placeholder text based on rate type
 * @param rateType
 * @returns getRateFieldPlaceholder(IRateTypes.ratePerMile)  // Enter rate per mile
 */
export function getRateFieldPlaceholder<K extends IRateTypes>(
  rateType: K
): TRateFieldPlaceholders[K] {
  return RATE_FIELD_PLACEHOLDERS[rateType]
}
